var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertsF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    fill: "#4987FF",
    stroke: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7426 15.0967H31.871V10.0645H28.7426C26.9006 10.0667 25.1347 10.7994 23.8322 12.1019C22.5297 13.4044 21.797 15.1703 21.7948 17.0123V20.129H18.4517V25.1612H21.8065V41.8314H26.8388V25.1612H30.2288L31.2219 20.129H26.8388V16.0881C26.8427 15.8261 26.9486 15.5759 27.134 15.3908C27.3195 15.2057 27.5698 15.1002 27.8318 15.0967H28.7426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertsF);
export default __webpack_public_path__ + "static/media/Experts_f.257601cdfbfe073ae56e6d8affd31064.svg";
export { ForwardRef as ReactComponent };